import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { createNewAvaturnAvatar } from '~/api';
import { useModal } from '~/hooks';
import useToast from '~/store/useToast';

const useCreateNewAvaturnMutation = () => {
  const { showToast } = useToast();
  const { openModal } = useModal();

  return useMutation({
    mutationFn: createNewAvaturnAvatar,
    onError: (error: any) => {
      console.error(error);

      if (error?.status === 504 || error?.statusCode === 504) {
        openModal({
          title: 'Try Again',
          content: 'Failed to process the image. Please try again.',
          buttonName: 'Retry',
          type: 'single',
        });
      } else {
        showToast('error', error.message);
      }
    },
  });
};

export default useCreateNewAvaturnMutation;
